<form name="loginForm" (ngSubmit)="onSubmit()" novalidate>
    <app-modal-title i18n>Product Download</app-modal-title>
    <app-modal-body>
        <div id="overwrite-body" class="ot-m-1 ot-mb-1">
            <p id="overwrite-message">{{overwriteMessage}}</p>
            <div class="ot-mr-3 ot-ml-3 list-area" [style.height]="viewheight">
                <app-datatable [identifier]="'overwrite-list'" [cols]="cols" [rows]="rows" [islist]="true" [sortdata]="true"></app-datatable>
            </div>
        </div>
    </app-modal-body>
    <app-modal-footer>
        <button id="yes-button" type="submit" otsc-button color="primary" i18n-title title="Yes" i18n> 
            Yes
        </button>
        <button id="no-button" type="button" otsc-button color="secondary" i18n-title title="No" (click)="onClose()" [disabled]="processing" i18n>
            No
        </button>
    </app-modal-footer>
</form>    
